import type { ImagesDefinition } from 'types/images'

export const SHARED_IMAGES = {
  didYouKnow: {
    harvardMedicalLight: {
      width: 122,
      height: 40,
      srcSet: [
        '/images/shared/did-you-know/harvard_medical.webp',
        '/images/shared/did-you-know/harvard_medical@2x.webp',
      ],
    },
    harvardMedicalDark: {
      width: 122,
      height: 40,
      srcSet: [
        '/images/shared/did-you-know/harvard_medical_dark.webp',
        '/images/shared/did-you-know/harvard_medical_dark@2x.webp',
      ],
    },
    harvardChanLight: {
      width: 149,
      height: 40,
      srcSet: [
        '/images/shared/did-you-know/harvard_th.webp',
        '/images/shared/did-you-know/harvard_th@2x.webp',
      ],
    },
    harvardChanDark: {
      width: 149,
      height: 40,
      srcSet: [
        '/images/shared/did-you-know/harvard_th_dark.webp',
        '/images/shared/did-you-know/harvard_th_dark@2x.webp',
      ],
    },
    southCarolinaLight: {
      width: 122,
      height: 40,
      srcSet: [
        '/images/shared/did-you-know/south_carolina.webp',
        '/images/shared/did-you-know/south_carolina@2x.webp',
      ],
    },
    southCarolinaDark: {
      width: 122,
      height: 40,
      srcSet: [
        '/images/shared/did-you-know/south_carolina_dark.webp',
        '/images/shared/did-you-know/south_carolina_dark@2x.webp',
      ],
    },
  },
  welcomeAgeBuckets: {
    eighteenToTwentyNine: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/shared/welcome-age-buckets/welcome_age_buckets_option_18_29.webp',
        '/images/shared/welcome-age-buckets/welcome_age_buckets_option_18_29@2x.webp',
      ],
    },
    thirtyToThirtyNine: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/shared/welcome-age-buckets/welcome_age_buckets_option_30_39.webp',
        '/images/shared/welcome-age-buckets/welcome_age_buckets_option_30_39@2x.webp',
      ],
    },
    fortyToFortyNine: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/shared/welcome-age-buckets/welcome_age_buckets_option_40_49.webp',
        '/images/shared/welcome-age-buckets/welcome_age_buckets_option_40_49@2x.webp',
      ],
    },
    fiftyPlus: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/shared/welcome-age-buckets/welcome_age_buckets_option_50_plus.webp',
        '/images/shared/welcome-age-buckets/welcome_age_buckets_option_50_plus@2x.webp',
      ],
    },
  },
  credibilityPitch: {
    ratingLight: {
      width: 100,
      height: 100,
      srcSet: [
        '/images/shared/credibility-pitch/rating.webp',
        '/images/shared/credibility-pitch/rating@2x.webp',
      ],
    },
    ratingDark: {
      width: 100,
      height: 100,
      srcSet: [
        '/images/shared/credibility-pitch/rating_white.webp',
        '/images/shared/credibility-pitch/rating_white@2x.webp',
      ],
    },
    appStoreLight: {
      width: 100,
      height: 100,
      srcSet: [
        '/images/shared/credibility-pitch/app_store.webp',
        '/images/shared/credibility-pitch/app_store@2x.webp',
      ],
    },
    appStoreDark: {
      width: 100,
      height: 100,
      srcSet: [
        '/images/shared/credibility-pitch/app_store_white.webp',
        '/images/shared/credibility-pitch/app_store_white@2x.webp',
      ],
    },
    googlePlayLight: {
      width: 100,
      height: 100,
      srcSet: [
        '/images/shared/credibility-pitch/google_play.webp',
        '/images/shared/credibility-pitch/google_play@2x.webp',
      ],
    },
    googlePlayDark: {
      width: 100,
      height: 100,
      srcSet: [
        '/images/shared/credibility-pitch/google_play_white.webp',
        '/images/shared/credibility-pitch/google_play_white@2x.webp',
      ],
    },
  },
  socialProofMillions: {
    mediaLogosAllBlack: {
      width: 370,
      height: 40,
      srcSet: [
        '/images/shared/media-logos/media_logos_all_black.webp',
        '/images/shared/media-logos/media_logos_all_black@2x.webp',
      ],
    },
    mediaLogosAllWhite: {
      width: 370,
      height: 40,
      srcSet: [
        '/images/shared/media-logos/media_logos_all_white.webp',
        '/images/shared/media-logos/media_logos_all_white@2x.webp',
      ],
    },
    orbitFemale01: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/orbit/female_01.webp'],
    },
    orbitFemale02: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/orbit/female_02.webp'],
    },
    orbitFemale03: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/orbit/female_03.webp'],
    },
    orbitFemale04: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/orbit/female_04.webp'],
    },
    orbitFemale05: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/orbit/female_05.webp'],
    },
    orbitFemale06: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/orbit/female_06.webp'],
    },
    orbitFemale07: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/orbit/female_07.webp'],
    },
    orbitFemale08: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/orbit/female_08.webp'],
    },
    orbitFemale09: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/orbit/female_09.webp'],
    },
    orbitFemale10: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/orbit/female_10.webp'],
    },
    orbitFemale11: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/orbit/female_11.webp'],
    },
    orbitMale01: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/orbit/male_01.webp'],
    },
    orbitMale02: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/orbit/male_02.webp'],
    },
    orbitMale03: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/orbit/male_03.webp'],
    },
    orbitMale04: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/orbit/male_04.webp'],
    },
    orbitMale05: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/orbit/male_05.webp'],
    },
    orbitMale06: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/orbit/male_06.webp'],
    },
    orbitMale07: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/orbit/male_07.webp'],
    },
    orbitMale08: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/orbit/male_08.webp'],
    },
    orbitMale09: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/orbit/male_09.webp'],
    },
    orbitMale10: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/orbit/male_10.webp'],
    },
    orbitMale11: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/orbit/male_11.webp'],
    },
    mapFemale01: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/map/female_01.webp'],
    },
    mapFemale02: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/map/female_02.webp'],
    },
    mapFemale03: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/map/female_03.webp'],
    },
    mapFemale04: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/map/female_04.webp'],
    },
    mapFemale05: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/map/female_05.webp'],
    },
    mapFemale06: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/map/female_06.webp'],
    },
    mapFemale07: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/map/female_07.webp'],
    },
    mapFemale08: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/map/female_08.webp'],
    },
    mapFemale09: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/map/female_09.webp'],
    },
    mapFemale10: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/map/female_10.webp'],
    },
    mapFemale11: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/map/female_11.webp'],
    },
    mapFemale12: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/map/female_12.webp'],
    },
    mapMale01: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/map/male_01.webp'],
    },
    mapMale02: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/map/male_02.webp'],
    },
    mapMale03: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/map/male_03.webp'],
    },
    mapMale04: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/map/male_04.webp'],
    },
    mapMale05: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/map/male_05.webp'],
    },
    mapMale06: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/map/male_06.webp'],
    },
    mapMale07: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/map/male_07.webp'],
    },
    mapMale08: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/map/male_08.webp'],
    },
    mapMale09: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/map/male_09.webp'],
    },
    mapMale10: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/map/male_10.webp'],
    },
    mapMale11: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/map/male_11.webp'],
    },
    mapMale12: {
      width: 100,
      height: 100,
      srcSet: ['/images/shared/social-proof-millions/map/male_12.webp'],
    },
  },
  planGenerator: {
    familyDiseases3d: {
      width: 92,
      height: 92,
      srcSet: [
        '/images/shared/plan-generator/family_diseases_3d.webp',
        '/images/shared/plan-generator/family_diseases_3d@2x.webp',
      ],
    },
    postLunchSlump3d: {
      width: 92,
      height: 92,
      srcSet: [
        '/images/shared/plan-generator/post_lunch_slump_3d.webp',
        '/images/shared/plan-generator/post_lunch_slump_3d@2x.webp',
      ],
    },
    mealTimes3d: {
      width: 92,
      height: 92,
      srcSet: [
        '/images/shared/plan-generator/meal_times_3d.webp',
        '/images/shared/plan-generator/meal_times_3d@2x.webp',
      ],
    },
  },
  success: {
    phones: {
      width: 402,
      height: 402,
      srcSet: [
        '/images/shared/success/success.webp',
        '/images/shared/success/success@2x.webp',
      ],
    },
  },
  subscription: {
    featuredInWhite: {
      width: 264,
      height: 98,
      srcSet: [
        '/images/subscription/featured_in_white.webp',
        '/images/subscription/featured_in_white@2x.webp',
      ],
    },
    featuredInDark: {
      width: 264,
      height: 98,
      srcSet: [
        '/images/subscription/featured_in_dark.webp',
        '/images/subscription/featured_in_dark@2x.webp',
      ],
    },
    flex: {
      width: 286,
      height: 171,
      srcSet: [
        '/images/subscription/flex.webp',
        '/images/subscription/flex@2x.webp',
      ],
    },
    giftVoucher: {
      width: 286,
      height: 171,
      srcSet: [
        '/images/subscription/gift_voucher.webp',
        '/images/subscription/gift_voucher@2x.webp',
      ],
    },
    isic: {
      width: 80,
      height: 80,
      srcSet: ['/images/subscription/isic_logo.svg'],
    },
    itic: {
      width: 80,
      height: 80,
      srcSet: ['/images/subscription/itic_logo.svg'],
    },
    logoAmex: {
      width: 33,
      height: 22,
      srcSet: ['/images/subscription/money-back/logo_amex.svg'],
    },
    logoApplePay: {
      width: 33,
      height: 22,
      srcSet: ['/images/subscription/money-back/logo_apple_pay.svg'],
    },
    logoDiscover: {
      width: 33,
      height: 22,
      srcSet: ['/images/subscription/money-back/logo_discover.svg'],
    },
    logoGooglePay: {
      width: 33,
      height: 22,
      srcSet: ['/images/subscription/money-back/logo_google_pay.svg'],
    },
    logoMastercard: {
      width: 33,
      height: 22,
      srcSet: ['/images/subscription/money-back/logo_mastercard.svg'],
    },
    logoPayPal: {
      width: 33,
      height: 22,
      srcSet: ['/images/subscription/money-back/logo_pay_pal.svg'],
    },
    logoVisa: {
      width: 33,
      height: 22,
      srcSet: ['/images/subscription/money-back/logo_visa.svg'],
    },
    moneyBack: {
      width: 124,
      height: 100,
      srcSet: ['/images/subscription/money-back/money_back.svg'],
    },
    promoDiscountBlue: {
      width: 200,
      height: 105,
      srcSet: [
        '/images/subscription/promo/discount_blue.webp',
        '/images/subscription/promo/discount_blue@2x.webp',
      ],
    },
    promoReferralBlue: {
      width: 216,
      height: 216,
      srcSet: [
        '/images/subscription/promo/referral_blue.webp',
        '/images/subscription/promo/referral_blue@2x.webp',
      ],
    },
    // Printable card
    printableFemaleAsipi: {
      width: 42,
      height: 52,
      srcSet: ['/images/subscription/printable-card/printable_fff_asipi.webp'],
    },
    printableFemaleChairYoNormal: {
      width: 42,
      height: 52,
      srcSet: [
        '/images/subscription/printable-card/printable_fff_chairyo-normal.webp',
      ],
    },
    printableFemaleChairYoTaiChi: {
      width: 42,
      height: 52,
      srcSet: [
        '/images/subscription/printable-card/printable_fff_chairyo-taichi.webp',
      ],
    },
    printableFemaleHomePi: {
      width: 42,
      height: 52,
      srcSet: ['/images/subscription/printable-card/printable_fff_homepi.webp'],
    },
    printableFemaleIndoorWalk: {
      width: 42,
      height: 52,
      srcSet: [
        '/images/subscription/printable-card/printable_fff_indoor_walk.webp',
      ],
    },
    printableFemaleMilica: {
      width: 42,
      height: 52,
      srcSet: ['/images/subscription/printable-card/printable_fff_milica.webp'],
    },
    printableFemaleWallPi: {
      width: 42,
      height: 52,
      srcSet: ['/images/subscription/printable-card/printable_fff_wallpi.webp'],
    },
    printableMaleChairYoNormal: {
      width: 42,
      height: 52,
      srcSet: [
        '/images/subscription/printable-card/printable_mmm_chairyo-normal.webp',
      ],
    },
    printableMaleChairYoTaiChi: {
      width: 42,
      height: 52,
      srcSet: [
        '/images/subscription/printable-card/printable_mmm_chairyo-taichi.webp',
      ],
    },
    printableMaleMilica: {
      width: 42,
      height: 52,
      srcSet: ['/images/subscription/printable-card/printable_mmm_milica.webp'],
    },
    printableOlderFemaleChairYoNormal: {
      width: 42,
      height: 52,
      srcSet: [
        '/images/subscription/printable-card/printable_f-older_chairyo-normal.webp',
      ],
    },
    printableOlderMaleChairYoNormal: {
      width: 42,
      height: 52,
      srcSet: [
        '/images/subscription/printable-card/printable_m-older_chairyo-normal.webp',
      ],
    },
    printableOlderMaleChairYoTaiChi: {
      width: 42,
      height: 52,
      srcSet: [
        '/images/subscription/printable-card/printable_m-older_chairyo-taichi.webp',
      ],
    },
    // User results
    avatarFemale1: {
      width: 48,
      height: 48,
      srcSet: ['/images/subscription/user-result/avatar_female_1.webp'],
    },
    avatarFemale2: {
      width: 48,
      height: 48,
      srcSet: ['/images/subscription/user-result/avatar_female_2.webp'],
    },
    avatarFemale3: {
      width: 48,
      height: 48,
      srcSet: ['/images/subscription/user-result/avatar_female_3.webp'],
    },
    avatarMale1: {
      width: 48,
      height: 48,
      srcSet: ['/images/subscription/user-result/avatar_male_1.webp'],
    },
    avatarMale2: {
      width: 48,
      height: 48,
      srcSet: ['/images/subscription/user-result/avatar_male_2.webp'],
    },
    avatarMale3: {
      width: 48,
      height: 48,
      srcSet: ['/images/subscription/user-result/avatar_male_3.webp'],
    },
    femaleRefAfter1: {
      width: 282,
      height: 304,
      srcSet: [
        '/images/subscription/user-result/female_ref_after_1.webp',
        '/images/subscription/user-result/female_ref_after_1@2x.webp',
      ],
    },
    femaleRefAfter2: {
      width: 282,
      height: 304,
      srcSet: [
        '/images/subscription/user-result/female_ref_after_2.webp',
        '/images/subscription/user-result/female_ref_after_2@2x.webp',
      ],
    },
    femaleRefAfter3: {
      width: 282,
      height: 304,
      srcSet: [
        '/images/subscription/user-result/female_ref_after_3.webp',
        '/images/subscription/user-result/female_ref_after_3@2x.webp',
      ],
    },
    femaleRefBefore1: {
      width: 282,
      height: 304,
      srcSet: [
        '/images/subscription/user-result/female_ref_before_1.webp',
        '/images/subscription/user-result/female_ref_before_1@2x.webp',
      ],
    },
    femaleRefBefore2: {
      width: 282,
      height: 304,
      srcSet: [
        '/images/subscription/user-result/female_ref_before_2.webp',
        '/images/subscription/user-result/female_ref_before_2@2x.webp',
      ],
    },
    femaleRefBefore3: {
      width: 282,
      height: 304,
      srcSet: [
        '/images/subscription/user-result/female_ref_before_3.webp',
        '/images/subscription/user-result/female_ref_before_3@2x.webp',
      ],
    },
    maleRefAfter1: {
      width: 282,
      height: 304,
      srcSet: [
        '/images/subscription/user-result/male_ref_after_1.webp',
        '/images/subscription/user-result/male_ref_after_1@2x.webp',
      ],
    },
    maleRefAfter2: {
      width: 282,
      height: 304,
      srcSet: [
        '/images/subscription/user-result/male_ref_after_2.webp',
        '/images/subscription/user-result/male_ref_after_2@2x.webp',
      ],
    },
    maleRefAfter3: {
      width: 282,
      height: 304,
      srcSet: [
        '/images/subscription/user-result/male_ref_after_3.webp',
        '/images/subscription/user-result/male_ref_after_3@2x.webp',
      ],
    },
    maleRefBefore1: {
      width: 282,
      height: 304,
      srcSet: [
        '/images/subscription/user-result/male_ref_before_1.webp',
        '/images/subscription/user-result/male_ref_before_1@2x.webp',
      ],
    },
    maleRefBefore2: {
      width: 282,
      height: 304,
      srcSet: [
        '/images/subscription/user-result/male_ref_before_2.webp',
        '/images/subscription/user-result/male_ref_before_2@2x.webp',
      ],
    },
    maleRefBefore3: {
      width: 282,
      height: 304,
      srcSet: [
        '/images/subscription/user-result/male_ref_before_3.webp',
        '/images/subscription/user-result/male_ref_before_3@2x.webp',
      ],
    },
  },
  exclusiveOffer: {
    tutorial: {
      width: 560,
      height: 251,
      srcSet: [
        '/images/exclusive-offer/upsell_card_tutorial.webp',
        '/images/exclusive-offer/upsell_card_tutorial@2x.webp',
      ],
    },
  },
} satisfies ImagesDefinition
